import { render } from "./TimeGroupPage.vue?vue&type=template&id=00958896&ts=true"
import script from "./TimeGroupPage.vue?vue&type=script&lang=ts"
export * from "./TimeGroupPage.vue?vue&type=script&lang=ts"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/ZaloOA_LienChieu/ZaloOA_LienChieu_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__